module.exports = __webpack_public_path__ + "static/media/optimum-business.7b9eefbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/new_components/generic/png/optimum-business.png
// module id = 7366
// module chunks = 4